<template>
  <div class="content">
    <DebugInfo />
    <QBResult
      v-if="isHitQBResult"
      :get-doc-info="getDocInfo"
      :get-short-video-play-info="getShortVideoPlayInfo"
      @onTagChange="handleTagChange"
    />
    <H5Result
      v-else
      :get-doc-info="getDocInfo"
      :get-short-video-play-info="getShortVideoPlayInfo"
    />
  </div>
</template>

<script>
import { throttle  } from '@asset/js/util';
import { mapState } from 'vuex';

import DebugInfo from './components/DebugInfo.vue';
import H5Result from './components/H5Result.vue';
import QBResult from './components/QBResult.vue';
const { init: initSpver } = require('../common/js/searchNav');
const { getSsrUigsParams } = require('../common/js/util');

export default {
  components: {
    H5Result,
    QBResult,
    DebugInfo,
  },
  computed: {
    ...mapState('common', ['$config']),
    ...mapState('search', [
      'query',
      'shortVideo',
      'soutuiExpInfo',
      'maxEnd',
      'spver',
      'sUuid',
    ]),
    isHitQBResult() {
      // TAB实验大图浏览态开关
      const { iskd, isHitQBResult, tabExpInfo = {} } = this.$config || {};
      console.log(888, iskd === 1 && isHitQBResult && tabExpInfo.supportScanResult);
      return iskd === 1 && isHitQBResult && tabExpInfo.supportScanResult;
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('search/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_SEARCH_ERROR]', err));
  },
  beforeMount() {
    window.UIGS_PARA = this.initUigsParams();
  },
  mounted() {
    // 搜索框头部初始化
    const { spver = '' } = this.$route.query;
    initSpver(spver);
    window.addEventListener('scroll', throttle(this.scrollHandler, 200));
    this.scrollHandler();
    // 搜索结果pv日志上报
    this.sendResultUigs();
    // Hippy预加载逻辑
    this.handleHippyPreload();
    // approveToken发送
    this.sendApprove();
  },
  methods: {
    initUigsParams() {
      const {
        isNa: is_na = 0,
        isKd: is_mix = 0,
        isHitKd: hitKd = 0,
        qua = '',
        guid = '',
        noHead,
        tabExpInfo,
        uuid = '',
        abtest = '',
        hippyVersion = '',
        idc = '',
      } = this.$config || {};
      const tabExpIds = tabExpInfo.tabExpIds || '';
      const {
        entryScene = '',
        entryTime = '',
        jump_from: jumpFrom = '',
        s_from: sFrom = '',
        kdExpId = '',
        dp = '',
      } = this.$route.query || {};
      const { kdExpId: kdExpIdAlias = '', wordType = '' } = this.soutuiExpInfo || {};
      const uigsParams = {
        query: encodeURIComponent(this.query),
        pagetype: 'search_result',
        pageversion: 'other',
        short_result: this.maxEnd,
        qo: 0,
        spver: this.spver,
        tab_type: 'all',
        uuid: this.sUuid || uuid,
        suuid: this.sUuid || uuid,
        abtest,
        is_na,
        is_mix,
        hitKd,
        qua,
        guid,
        hippyVersion,
        searchbtn: noHead ? 0 : 1,
        tabExpIds,
        entryScene,
        entryTime,
        jump_from: jumpFrom,
        s_from: sFrom,
        wordType,
        kdExpId: kdExpIdAlias || kdExpId || '',
        dp,
        idc,
      };
      return getSsrUigsParams(uigsParams);
    },
    sendResultUigs() {
      const { approveToken } = this.$config || {};
      const kdParams = { ...window.UIGS_PARA, isApprove: approveToken ? 1 : 0 };

      // 看点结果上报
      if (this.shortVideo.length) {
        this.$uigsKd.send({
          ...kdParams,
          pagetype: 'search_result',
          query: encodeURIComponent(this.query),
        });
      } else {
        this.$uigsKd.send({
          ...kdParams,
          pagetype: 'search_no_result',
          noResultType: 'tab',
        });
      }
    },
    scrollHandler() {
      const winH = window.innerHeight;
      const $reportList = document.querySelectorAll('[data-report][data-exposed="false"]');
      if (!$reportList.length) return false;
      [].forEach.call($reportList, (item) => {
        const { top } = item.getBoundingClientRect();
        if (top >= 0 && top < winH) {
          item.setAttribute('data-exposed', true);
          const { report: reportIndex } = item.dataset;
          const report = this.getDocInfo(this.shortVideo[+reportIndex], reportIndex);
          this.$uigsKd.send({
            ...window.UIGS_PARA,
            ...report,
            pagetype: 'result',
          });
        }
      });
    },
    /**
     * 获取doc基本信息
     */
    getDocInfo(item, index) {
      return {
        docid: item.docid || '',
        doc_type: 'short',
        doc_pos: +index + 1,
        doc_from: item.docfrom,
        res_type: item.resType,
        res_stype: item.resSType,
        show_tag_type: item.showTagType || '',
        show_tag_name: item.showTagName || '',
      };
    },
    /**
     * 获取点出播放信息
     */
    getShortVideoPlayInfo({ item, index }) {
      const playInfoReport = item.posName ? {} : {
        play_type: 'video',
        play_url: encodeURIComponent(item.url),
        play_site: item.site_d || '',
      };
      const docInfoObj = this.getDocInfo(item, index);
      const reportObj = {
        ...playInfoReport,
        ...docInfoObj,
      };
      return Object.keys(reportObj).reduce((acc, key, index) => {
        const reportStr = `${key}=${reportObj[key]}`;
        return acc + (index === 0 ? reportStr : `&${reportStr}`);
      }, '');
    },
    handleTagChange() {
      window.UIGS_PARA = this.initUigsParams();
      this.sendResultUigs();
    },
    handleHippyPreload() {
      // 有无短视频
      if (this.shortVideo.length) {
        this.sendHippyPreloadUigs('has_short_video');
      }
      // 有无NA短视频
      if (this.shortVideo.some(item => item.resType === 'native')) {
        this.sendHippyPreloadUigs('has_na_video');
      }
      const preload = window.browser
        && window.browser.search
        && window.browser.search.searchVideoHippyPreload;

      // 调用和回调上报
      if (typeof preload === 'function') {
        const timeNow = Date.now();
        this.sendHippyPreloadUigs('call');
        preload((res) => {
          const preloadCost = Date.now() - timeNow;
          this.sendHippyPreloadUigs(`done${res.resultCode}`, preloadCost);
        }, {});
      }
    },
    sendHippyPreloadUigs(type, preloadCost) {
      const params = window.UIGS_PARA || {};
      const cost = preloadCost ? { preloadCost } : {};
      this.$uigsKd.send({
        ...params,
        ...cost,
        pagetype: 'search_video_preload',
        type,
      });
    },
    sendApprove() {
      const { uuid, approveToken } = this.$config || {};
      if (uuid && approveToken) {
        const img = new Image();
        img.src = `/approve?uuid=${encodeURIComponent(uuid)}&token=${encodeURIComponent(approveToken)}`;
      }
    },
  },
};
</script>
